<template>
  <div class="mapbar-container">
    <div class="input-group map-search">
      <div class="input-group-prepend">
        <span class="input-group-text" id="map-search-icon-addon" :style="{ 'background-color': 'white' }">
          <font-awesome-icon icon="search" size="1x" :style="{ color: 'gray' }" />
        </span>
      </div>
      <input
        type="text"
        class="form-control"
        placeholder="Поиск по автомобилю, номеру"
        aria-label="Поиск по автомобилю, номеру"
        aria-describedby="map-search-icon-addon"
        v-model="filter"
      />
    </div>
    <div class="car-rows" ref="refCarContainer">
      <MapCard class="location-map-card" v-for="car in filtredCars" :ref="`refCarCard${car.id}`" :key="car.id" :car="car" />
    </div>
    <CardSelected v-if="isSelected" />
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
export default {
  name: 'MapBar',
  computed: {
    ...mapState('taxi/mapcars', {
      cars: state => state.items.filter(car => car.imei),
      filtredCars () {
        return this.cars.filter(car => !this.filter ||
          car.registration_plate.toUpperCase().includes(this.filter.toUpperCase()) ||
          car.brand.toUpperCase().includes(this.filter.toUpperCase()) ||
          car.model.toUpperCase().includes(this.filter.toUpperCase()))
      }
    }),
    ...mapGetters('taxi/mapcars', [
      'getSelected'
    ]),
    isSelected () {
      return !!this.getSelected
    }
  },
  methods: {
    ...mapActions('taxi/mapcars', [
      'selectCar'
    ]),
    unsetSelectedCar () {
      this.selectCar(undefined)
    }
  },
  data () {
    return {
      toggle: false,
      filter: ''
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/scss/globals.scss";

  .location-map-card {
    margin-top: 1rem;
  }
  .map-search {
    position: sticky;
    top: 0;
    z-index:9;
    padding-top: 0.4rem;
    background-color: white;
  }
</style>
